import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
@Component({
  selector: 'app-patient-consent-form',
  templateUrl: './patient-consent-form.component.html',
  styleUrls: ['./patient-consent-form.component.scss']
})
export class PatientConsentFormComponent implements OnInit {



  caseStudyPaperWork
  @Input('learner') learnerData;
  @Input('singleJob') jobData;
  @Input('assesment') assessmentPlanEdit;
  learnerId: any;
  jobId: any;
  assessmentEdit: any;
  learnerSign = false
  patientSign = false
  loading = false
  isEdit:boolean = false
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService
  ) { }

  ngOnInit() {
    if(!this.isEdit)
    this.createForm()
  }



  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue
    }

    if (changes.jobData && changes.jobData.currentValue) {
      this.jobId = changes.jobData.currentValue[0]
    }
    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
      this.assessmentEdit = changes.assessmentPlanEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);

      if (this.assessmentPlanEdit && this.assessmentPlanEdit.caseStudyPaperWork) {
        if (this.assessmentPlanEdit.caseStudyPaperWork && this.assessmentPlanEdit.caseStudyPaperWork.patientSign != "") {
          this.patientSign = true
        }
        if (this.assessmentPlanEdit.caseStudyPaperWork && this.assessmentPlanEdit.caseStudyPaperWork.learnerSign != "") {
          this.learnerSign = true
        }
        this.isEdit = true
        this.createForm(this.assessmentEdit)
      }
      else {
        this.createForm()
      }

    }
  }



  // FORM CONTROL


  createForm(details?) {
    this.caseStudyPaperWork = new FormGroup({
      patientName: new FormControl((details && details.caseStudyPaperWork) ? details.caseStudyPaperWork.patientName : ''),
      patientSign: new FormControl((details && details.caseStudyPaperWork) ? details.caseStudyPaperWork.patientSign : ''),
      patientDate: new FormControl((details && details.caseStudyPaperWork) ? details.caseStudyPaperWork.patientDate : ''),
      learnerSign: new FormControl((details && details.caseStudyPaperWork) ? details.caseStudyPaperWork.learnerSign : ''),
      learnerDate: new FormControl((details && details.caseStudyPaperWork) ? details.caseStudyPaperWork.learnerDate : ''),
    })
  }


  // UTILITY

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  addSignature(fomrControl) {

    this.openDialog(SignaturePadComponent).subscribe((data) => {
      console.log("data of sign", data);
      if (data == undefined) return

      let newSign = data

      if (fomrControl == 'patientSign') {
        this.patientSign = true
        this.caseStudyPaperWork.patchValue({
          patientSign: newSign
        })
      }
      if (fomrControl == 'learnerSign') {
        this.learnerSign = true
        this.caseStudyPaperWork.patchValue({
          learnerSign: newSign
        })
      }


    })

  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'caseStudyPaperWork')
      this.caseStudyPaperWork.get(formControl).setValue(value);
  }



  // API CALL


  submitForm() {
    console.log("final form value", this.caseStudyPaperWork.value);
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId._id,
      version: true,
      details: {
        caseStudyPaperWork: this.caseStudyPaperWork.value,
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })
  }


}
